import React, { PropsWithChildren } from "react";
import { LoginReducer } from "./reducer";
import { ContextConstants } from "utils/constants";
import { LoginContextState } from "models/propTypes/loginPropTypes";
import { AuthEnums } from "models/enums";

const initialState: LoginContextState = {
  loginView: AuthEnums.LoginView.BankIdApp,
  setLoginView: (loginView: AuthEnums.LoginView) => {},
};

export const LoginContext = React.createContext<LoginContextState>(initialState);

const LoginContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(LoginReducer, initialState);

  const setLoginView = (loginView: AuthEnums.LoginView) => {
    dispatch({ type: ContextConstants.LoginActions.SET_LOGIN_VIEW, payload: loginView });
  };

  return (
    <LoginContext.Provider
      value={{
        ...state,
        setLoginView: setLoginView,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};

export default LoginContextProvider;
